module.exports = "https://cdn-shared.mathletics.com/teacher-modules/course-assign/25/assets/images/ec57477476c5c177e23ccece21955364.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/ico_class.svg
// module id = p1S/
// module chunks = 0